import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'react-bootstrap';

import { formatDate, _formatDate, _diff2Date } from '../../../utils';

import { makeGetToken } from '../../../lib/selector';

import RenderDatePicker from '../../input/renderDatePicker';
import { summaryOrdRequest } from '../../../containers/summary/actions';
import { v4 as uuidv4 } from 'uuid';
import { setToast } from '../../../containers/client/actions';
import { translate } from 'react-i18next';
class FormSearchSKL extends Component {
  submit = (values) => {
    const { txtSearch, typeOrder, startDate, endDate } = values;
    const { token, account } = this.props;

    console.log(account);

    const maxDay = token && token['config'] ? token['config']['maxDay'] : 90;

    const _typeOrder = typeOrder;
    const _diff = _diff2Date(endDate, startDate);
    if (_diff < 0) {
      this._handleToast('Thời gian tìm kiếm không hợp lệ');
      return;
    }
    if (_diff > maxDay) {
      this._handleToast('Chỉ được xuất báo cáo trong vòng ' + maxDay + ' ngày');
      return;
    }

    const _txtSearch = txtSearch ? txtSearch.toUpperCase() : '';
    const uuid = uuidv4();

    const params = {
      group: 'CORE',
      user: token.user,
      session: token.session,
      cmd: 'OrderHis',
      rqId: uuid,
      channel: 'WTS',
      data: {
        acntNo: account.acntNo,
        subAcntNo: account.subAcntNo,
        fromDate: _formatDate(startDate),
        toDate: _formatDate(endDate),
        symbol: _txtSearch,
        buySelTp: _typeOrder,
        ordrNo: '',
        ordrTrdTp: '',
        ordrStatTp: '',
      },
    };

    this.props.dispatch(summaryOrdRequest(params));
    this.props.saveParams(params);
  };

  componentDidUpdate(preProps) {
    const { account, reset } = this.props;

    if (account && account !== preProps.account) {
      reset();
      setTimeout(() => {
        if (this.refSubmit) this.refSubmit.click();
      }, 100);
    }
  }

  _handleToast = (msg) => {
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
    };
    this.props.dispatch(setToast(toastMsg));
  };

  render() {
    const {
      handleSubmit,
      submitting,
      pristine,
      reset,
      startDate,
      endDate,
      t,
    } = this.props;

    const _loailenh = [
      { value: '1', label: t('txt-buy') },
      { value: '2', label: t('txt-sell') },
    ];

    return (
      <form
        className="p-2 mt-2 form-search-head"
        onSubmit={handleSubmit(this.submit)}
      >
        <Form.Group className="d-flex mb-0 p-2" controlId="formPlaintextSymbol">
          <label className="text-white-50 fz-14" style={{ width: '20mm' }}>
            {t('txt-search')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              name="txtSearch"
              component="input"
              maxLength="8"
              type="text"
              className="form-control form-input text-uppercase fz-14"
              placeholder={t('txt-symbol')}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {t('txt-label-from')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              classname="form-control form-input fz-14"
              name="startDate"
              type="start"
              startDate={startDate}
              endDate={endDate}
              component={RenderDatePicker}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {t('txt-label-to')}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              classname="form-control form-input fz-14"
              name="endDate"
              type="end"
              startDate={startDate}
              endDate={endDate}
              component={RenderDatePicker}
            />
          </div>
          <label className="text-white-50 fz-14 ml-2" style={{ width: '20mm' }}>
            {`${t('txt-buy')}/${t('txt-sell')}`}
          </label>
          <div style={{ width: '30mm' }}>
            <Field
              name="typeOrder"
              component="select"
              className="form-control form-input fz-14"
            >
              <option value="">{'--All--'}</option>
              {_loailenh.map((statusOption) => (
                <option value={statusOption.value} key={statusOption.value}>
                  {statusOption.label}
                </option>
              ))}
            </Field>
          </div>
          <button
            ref={(el) => (this.refSubmit = el)}
            type="submit"
            disabled={submitting}
            className="btn-reload fz-14 font-weight-bold text-white ml-2 w-auto"
          >
            {t('txt-search')}
          </button>
        </Form.Group>
      </form>
    );
  }
}

FormSearchSKL = reduxForm({
  form: 'saokelenh',
  enableReinitialize: true,
})(FormSearchSKL);

const selector = formValueSelector('saokelenh');

const makeMapStateToProps = () => {
  const getToken = makeGetToken();

  const mapStateToProps = (state, props) => {
    const token = getToken(state);
    const { txtSearch, typeOrder, startDate, endDate } = selector(
      state,
      'txtSearch',
      'typeOrder',
      'startDate',
      'endDate'
    );

    const numDay = token && token['config'] ? token['config']['numDay'] : 30;

    const d = new Date();
    d.setDate(d.getDate() - numDay);

    return {
      token,
      txtSearch,
      typeOrder,
      startDate,
      endDate,
      initialValues: {
        txtSearch: '',
        typeOrder: '',
        endDate: formatDate(new Date(), '/', 'dmy'),
        startDate: formatDate(d, '/', 'dmy'),
      },
    };
  };
  return mapStateToProps;
};

FormSearchSKL = connect(makeMapStateToProps)(FormSearchSKL);

export default translate('translations')(FormSearchSKL);
